export default "__VITE_ASSET__CZ3Wyv7c__"